module.exports = __webpack_public_path__ + "updown.svg?fcc7a0cfc7f048ccd0867a7161dc33c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/updown.svg
// module id = 231
// module chunks = 0